export const filter = {
  Filter_Operator_IN: _TL_('either of'),
  Filter_Operator_EQ: _TL_('equals'),
  Filter_Operator_NEQ: _TL_('does not equal'),
  Filter_Operator_Contains: _TL_('contains'),
  Filter_Operator_Not_Contains: _TL_('does not contain'),
  Filter_Operator_StartsWith: _TL_('begins with'),
  Filter_Operator_EndsWith: _TL_('ends with'),
  Filter_Operator_LT: _TL_('less than'),
  Filter_Operator_GT: _TL_('greater than'),
  Filter_Operator_LTE: _TL_('less than or equals'),
  Filter_Operator_GTE: _TL_('greater than or equals'),
  Filter_Validation_EnumSelectionRequired: _TL_('Select at least one option'),
  Filter_Validation_Common_Required: _TL_('Required field'),
  Filter_Validation_Common_Number: _TL_('Only numeric values allowed'),
  Filter_Validation_Common_Number_Range: _TL_('Numeric value out of allowed range'),
  Filter_Validation_Common_Integer: _TL_('Only integer values allowed'),
  Filter_Validation_Common_Date: _TL_('Incorrect date format'),
  Filter_Validation_Common_Id_Count: _TL_('Only {{maxCount}} items allowed'),
  Filter_Cannot_Have_Duplicate: _TL_('Cannot filter by duplicate property'),
  Filter_Remove: _TL_('Remove'),
  Filter_PredicateList_New: _TL_('Add another'),
  Performance: _TL_('Performance'),
  Filter_Key_AriaLabel: _TL_('What to filter'),
  Filter_Operator_AriaLabel: _TL_('How to filter'),
  Filter_Value_AriaLabel: _TL_('What to filter on'),
  SelectEntityOrEntities: _TL_('Select {0}', { comment: '{0} is placeholder for name' }),
  SelectedEntityOrEntities: _TL_(' selected {0}', { comment: '{0} is placeholder for name' }),
  Selector_LoadingText: _TL_('Loading...'),
  Selector_Check_All: _TL_('All'),
  Filter_Selector_MoreThanLimit: _TL_('Showing only the first {0} {1}. Narrow your search to find the right set of {1}', { comment: '{0} is the max number of items that can be displayed. {1} is the name of the entity in plural form, eg. campaigns, ads, labels etc.' }),
  NoEntityOrEntities: _TL_('No {0}', { comment: '{0} is placeholder for name' }),
  'Select all': _TL_('Select all'),
  'Deselect all': _TL_('Deselect all'),
  'Select this row': _TL_('Select this row'),
  'Deselect this row': _TL_('Deselect this row'),
};
